import React, { Component } from "react";

import images from "../../utils/images";

import { AuthWrapper } from "./index";

class PatientSignUpSuccess extends Component {
  render() {
    return (
      <AuthWrapper refFromOuter={this.props.scrlWprRef} showArt={this.props.showSvgArt}>
        <div className="d-flex pt-3 mb-5 tw:justify-center">
          <img
            alt="Sign up success"
            className="img-fluid"
            src={images("./authentication/sign-up-success.svg")}
          />
        </div>
        <h6>
          <b>Account Created Successfully</b>
        </h6>
        <p className="mt-4 fs-14">Thank you for filling out the information.</p>
        <p className="mt-4 fs-14">
          Your account is now being created. You’ll be redirected to your personalized Home
          dashboard momentarily.
        </p>
      </AuthWrapper>
    );
  }
}

export default PatientSignUpSuccess;
